import * as Types from './types';

import gql from 'graphql-tag';
import { BetFragmentDoc } from './fragments/bet';
export type BetsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  where: Types.V3_Bet_Filter;
}>;


export type BetsQuery = { __typename?: 'Query', v3Bets: Array<{ __typename?: 'V3_Bet', id: string, actor: string, amount: string, status: Types.BetStatus, potentialPayout: string, payout?: string | null, result?: Types.BetResult | null, odds: string, settledOdds?: string | null, redeemedTxHash?: string | null, affiliate: string, isRedeemed: boolean, isRedeemable: boolean, isCashedOut: boolean, freebetId?: string | null, isFreebetAmountReturnable?: boolean | null, paymasterContractAddress?: string | null, tokenId: string, createdAt: string, resolvedAt?: string | null, txHash: string, redeemedAt?: string | null, core: { __typename?: 'CoreContract', address: string, liquidityPool: { __typename?: 'LiquidityPoolContract', address: string } }, selections: Array<{ __typename?: 'V3_Selection', odds: string, result?: Types.SelectionResult | null, conditionKind: Types.V3_SelectionConditionKind, outcome: { __typename?: 'V3_Outcome', outcomeId: string, title?: string | null, condition: { __typename?: 'V3_Condition', conditionId: string, title?: string | null, status: Types.ConditionStatus, gameId: string, wonOutcomeIds?: Array<string> | null } } }>, cashout?: { __typename?: 'Cashout', payout: string } | null }> };


export const BetsDocument = gql`
    query Bets($first: Int, $skip: Int, $where: V3_Bet_filter!) {
  v3Bets(
    first: $first
    skip: $skip
    where: $where
    orderBy: createdBlockNumber
    orderDirection: desc
    subgraphError: allow
  ) {
    ...Bet
  }
}
    ${BetFragmentDoc}`;